export default __webpack_public_path__ + "static/media/premium-tile-icon-hera.3fc5c445b766a93216abd02af1464bec.svg";